import { useCallback, useEffect, useState } from 'react';
import { useFeatureFlags } from '@stitch-fix/sf-next';
import { SEOData } from '../../components/SEOData';
import { Layout } from '../../components/Layout';
import { SignIn } from '../../components/SignIn/SignIn';
import { SignInMachineContext } from '../../machines/sign-in/SignInMachineContext';
import { AwsWafScript } from '../../components/AwsWafScript';
import { ReCaptchaV3Controller } from '../../components/SignIn/ReCaptchaV3Controller';
import type { ExecuteReCaptcha } from '../../components/SignIn/ReCaptchaV3Controller';
export const RECAPTCHA_V3_FLAG = 'visitor.web.recaptcha_v3_enabled';
const Login = () => {
  const [isChatWidgetLogin, setIsChatWidgetLogin] = useState(false);
  const [executeReCaptcha, setExecuteReCaptcha] = useState<ExecuteReCaptcha>();
  // Read per render rather than once at import, so tests can stub the env var.
  const reCaptchaV3SiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3;
  const {
    featureFlags
  } = useFeatureFlags('visitor', [RECAPTCHA_V3_FLAG]);
  const reCaptchaV3Enabled = featureFlags?.[RECAPTCHA_V3_FLAG] === true;
  const reCaptchaV3Expected = reCaptchaV3Enabled && Boolean(reCaptchaV3SiteKey);
  const activeExecuteReCaptcha = reCaptchaV3Expected ? executeReCaptcha : undefined;
  const handleExecuteReCaptchaChange = useCallback((nextExecuteReCaptcha: ExecuteReCaptcha | undefined) => {
    setExecuteReCaptcha(() => nextExecuteReCaptcha);
  }, []);
  useEffect(() => {
    // using URLSearchParams to get the query params from the URL instead of
    // useRouter because useRouter returns undefined when the query param is not
    // explicitly set to a value
    // ex: `http://wwww.stitchfix.com/login?fromchatwidget`
    const params = new URLSearchParams(window.location.search);
    const fromChatWidget = params.get('fromchatwidget') !== null;

    // If the user is coming from the chat widget, we want to hide the header
    // and footer
    setIsChatWidgetLogin(fromChatWidget);
  }, []);
  return <>
      <Layout viewEventTrackingName="login" forceHideHeaderFooter={isChatWidgetLogin}>
        <SEOData canonicalUrl="https://www.stitchfix.com/login" title="Sign In | Personal Styling for Women, Men &amp; Kids" description="Looking to access your Stitch Fix account? Log in to get started, update your account, make exchanges and provide feedback for your Stylist!" openGraphDescription="You’ve got to try this! Stitch Fix is the personal styling service for men, women &amp; kids that sends handpicked clothing to your door (with free shipping &amp; returns!). Get started now." />
        <SignInMachineContext.Provider options={{
        input: {
          isWafEnabled: true
        }
      }}>
          <ReCaptchaV3Controller enabled={reCaptchaV3Enabled} siteKey={reCaptchaV3SiteKey} onExecuteReCaptchaChange={handleExecuteReCaptchaChange} />
          <SignIn executeReCaptcha={activeExecuteReCaptcha} reCaptchaV3Expected={reCaptchaV3Expected} />
        </SignInMachineContext.Provider>
      </Layout>
      <AwsWafScript page="/login" />
    </>;
};
export default Login;